import { render, staticRenderFns } from "./redemption-list.vue?vue&type=template&id=5294cac6&scoped=true&"
import script from "./redemption-list.vue?vue&type=script&lang=js&"
export * from "./redemption-list.vue?vue&type=script&lang=js&"
import style0 from "./redemption-list.vue?vue&type=style&index=0&id=5294cac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5294cac6",
  null
  
)

export default component.exports